import React from "react";

export class WeekViewCurrentTimeline extends React.PureComponent {
  computeHourMaxBottomMinutes = (schedulePeriods) => {
    if (schedulePeriods && schedulePeriods.length) {
      return Math.max(...schedulePeriods.map(p => (p.minuteOffset || 0) + (p.minuteLength || 0)))
    }
    return 60
  }

  computeTimelineProps = (ymd, hour, fieldsEquivalent, schedulePeriods, earliestHour, latestHour, currentTimeline) => {
    if (!currentTimeline || currentTimeline.ymd !== ymd) return null

    const beforeEarliest = currentTimeline.hour < earliestHour
    const afterLatest = currentTimeline.hour > latestHour

    const displayOnThisHour =
      currentTimeline.hour === hour ||
      (beforeEarliest && hour === earliestHour) ||
      (afterLatest && hour === latestHour)
    
    if (!displayOnThisHour) return null

    const hourMaxBottomMinutes = this.computeHourMaxBottomMinutes(schedulePeriods)
    const totalMaxBottomMinutes = hour * 60 + hourMaxBottomMinutes

    const isActive = !beforeEarliest && (!afterLatest || currentTimeline.totalMinutes < totalMaxBottomMinutes)

    let timelineTop
    if (beforeEarliest) {
      timelineTop = 0
    } else if (afterLatest) {
      timelineTop = isActive
        ? (currentTimeline.totalMinutes - hour * 60) * fieldsEquivalent
        : hourMaxBottomMinutes * fieldsEquivalent
    } else {
      timelineTop = currentTimeline.minute * fieldsEquivalent
    }

    const barColor = (beforeEarliest || (afterLatest && !isActive))
      ? '#BDBDBD'
      : '#595959'
    
    const circleSize = 12 * fieldsEquivalent
    const circleTop = timelineTop - circleSize / 2 + fieldsEquivalent

    return { timelineTop, barColor, circleSize, circleTop }
  }

  render() {
    const { ymd, hour, fieldsEquivalent, schedulePeriods, earliestHour, latestHour, currentTimeline} = this.props
    const tp = this.computeTimelineProps(ymd, hour, fieldsEquivalent, schedulePeriods, earliestHour, latestHour, currentTimeline)
    if (!tp) return null
    return (
      <>
        <div
          style={{
            position: 'absolute',
            top: tp.timelineTop,
            left: 0,
            height: 2 * fieldsEquivalent,
            width: '100%',
            backgroundColor: tp.barColor,
            zIndex: 1002
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: tp.circleTop,
            right: -2,
            width: tp.circleSize,
            height: tp.circleSize,
            borderRadius: '50%',
            backgroundColor: tp.barColor,
            zIndex: 1003
          }}
        />
      </>
    )
  }
}
